module.exports = JSEncrypt;